const config = {
    url: {
        // api: `http://localhost:8000/api`,
        api: `https://api.samsmy.cutscal.com/api`,
        main: `http://localhost:8000`,
        cdn: `http://localhost/8000`,
    },
    images: {
        sizes: {
            thumb: 'thumb',      // 200x200 - Thumbnails, lists, cards
            medium: 'medium',    // 600x600 - Product details, galleries
            large: 'large',      // 1200x1200 - Lightboxes, zoom views
            original: 'original' // Full resolution - Downloads
        },
        useCases: {
            list: 'thumb',       // Product/category lists
            card: 'medium',      // Product/category cards
            detail: 'large',     // Detail pages
            zoom: 'original'     // Lightbox/zoom views
        },
        placeholder: {
            product: '📦',
            category: '📁',
            user: '👤',
            default: '🖼️'
        },
        maxUploadSize: 5 * 1024 * 1024, // 5MB
        allowedTypes: ['image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'image/webp']
    },
    rules: {
        required: [(v) => !!v || 'Required field!'],
        name: [(v) => !!v || 'Required field!', (value) => (value && !(value.length > 100)) || 'Maximum 100 characters'],
        email: [(v) => !!v || 'Email address is not valid!', (v) => /.+@.+\..+/.test(v) || 'Invalid email address!'],
        phonenumber: [(v) => !!v || 'Phone number is not valid!', (v) => /^[+]?[\s./0-9]*[(]?[0-9]{1,4}[)]?[-\s./0-9]*$/g.test(v) || 'Invalid phone number!'],
    },
    regex: {
        name: /^[a-zA-Z -]{2,50}$/,
        mail: /^.+@.+$/,
        phonenumber: /^\+?[1-9]\d{3,14}$/,
        password: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\s\S])[ -~]{8,64}$/,
    },
    allowedredirectdomains: [
        'localhost:8080',
        'localhost:8081',
        'localhost:8082',
        'localhost:8083',
        'localhost:8084',
        'localhost:8085',
        'localhost:8086',
        'localhost:8087',
    ],
    dateformat: {
        weekday: 'short',
        year: 'numeric',
        day: 'numeric',
        month: 'long',
        hour: 'numeric',
        minute: 'numeric'
    },
}

export default config